import { css } from '@linaria/core';
import { FC, useEffect, useState } from 'react';
import { useFormikContext } from 'formik';
import { useCopyToClipboard } from 'react-use';
import cogoToast from 'components/ToastMessage/ToastMessage';
import { useDataCollection } from 'modules/AnalyticsCollection/AnalyticsCollectionProvider';
import SvgFile05Sm from './Icons/File05Sm';
import SvgCopy02Sm from './Icons/Copy02Sm';
import { TooltipWrapper } from './TooltipWrapper';
import { PlaygroundConfig } from '../types/playgroundConfig';
import { constructModelUrl } from '../utils/constructModelUrl';
export const ShareButtons: FC = () => {
  const {
    track
  } = useDataCollection();
  const {
    values
  } = useFormikContext<PlaygroundConfig>();
  const [copyLink, setCopyLink] = useState('');
  const modelUrl = constructModelUrl(values.model);
  const modelId = (values.model?.id as string);
  useEffect(() => {
    setCopyLink(modelUrl);
  }, [modelId]);
  const [, copyToClipboard] = useCopyToClipboard();
  const handleCopyClick = () => {
    copyToClipboard(copyLink);
    cogoToast.success('Model URL copied to clipboard');
  };
  if (!values.model?.id) return null;
  return <div className={shareButtonsContainer}>
      <TooltipWrapper toolTipText="View Model Page" side="bottom">
        <a href={modelUrl} className="view-model-button" onClick={() => {
        track('Playground -> View Model Page', {
          userId: values.model?.user_id,
          appId: values.model?.app_id,
          modelId: values.model?.id
        });
      }}>
          <SvgFile05Sm className={shareButton} />
        </a>
      </TooltipWrapper>
      <TooltipWrapper toolTipText="Copy Model URL" side="bottom">
        <button type="button" onClick={handleCopyClick} className="copy-button">
          <SvgCopy02Sm className={shareButton} />
        </button>
      </TooltipWrapper>
    </div>;
};
const shareButtonsContainer = "odules__Playground__Components__ShareButtons_tsx-shareButtonsContainer-sb12prj";
const shareButton = "odules__Playground__Components__ShareButtons_tsx-shareButton-s198xnkj";

require("./ShareButtons.linaria.module.css!=!../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./ShareButtons.tsx");